import { render, staticRenderFns } from "./FeatureAdd.vue?vue&type=template&id=74cce796&scoped=true&"
import script from "./FeatureAdd.vue?vue&type=script&lang=js&"
export * from "./FeatureAdd.vue?vue&type=script&lang=js&"
import style0 from "./FeatureAdd.vue?vue&type=style&index=0&id=74cce796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cce796",
  null
  
)

export default component.exports